function isRoleFound(userRoles: string[], role: string): boolean {
  return userRoles.includes(role)
}

export default isRoleFound
